import { Group } from '@mantine/core';
import { GeneratedDocument } from '../hooks/useGeneratedDocuments';
import DownloadDocumentControl from './DownloadDocumentControl';
import GeneratingIndicator from './GeneratingIndicator';
import RenameDocumentControl from './RenameDocumentControl';

type Props = {
  doc: GeneratedDocument;
  onDownload: (fileId: number) => void;
  showGeneratingIndicator?: boolean;
};

export default function GeneratedDocumentInlineActions({
  doc,
  onDownload,
  showGeneratingIndicator = false,
}: Props) {
  const { renameFileId, fileId, displayName, backgroundProcess } = doc;

  const isGenerating =
    backgroundProcess?.status === 'PENDING' || backgroundProcess?.status === 'PROCESSING';
  if (isGenerating) {
    if (!showGeneratingIndicator) return null;
    return <GeneratingIndicator />;
  }

  if (renameFileId === undefined && fileId === undefined) return null;

  return (
    <Group gap="xxs" wrap="nowrap">
      {renameFileId !== undefined && (
        <RenameDocumentControl fileId={renameFileId} currentName={displayName} variant="chip" />
      )}
      {fileId !== undefined && <DownloadDocumentControl onDownload={() => onDownload(fileId)} />}
    </Group>
  );
}
